import { t } from '@lingui/macro'

export const ATTRIBUTE_TRANS_MAP = {
  selfie: t`photo`,
  given_names: t`given names`,
  family_name: t`family name`,
  full_name: t`full name`,
  date_of_birth: t`date of birth`,
  email_address: t`email address`,
  postal_address: t`address`,
  structured_postal_address: t`address`,
  gender: t`gender`,
  nationality: t`nationality`,
  phone_number: t`phone number`,
  document_details: t`document details`,
  document_images: t`document images`,
}

export const DOCUMENT_SOURCE_TRANS_MAP = {
  DRIVING_LICENCE: t`Driving Licence`,
  NATIONAL_ID: t`National ID`,
  PASS_CARD: t`PASS card`,
  PASSPORT: t`Passport`
}

export const DOCUMENT_SUBTYPE_TEXT_MAP = {
  CITIZENCARD: 'Citizen card',
  OCR: 'OCR',
  NFC: 'NFC',
  AADHAAR: 'Aadhaar',
  STATE_ID: 'State ID',
  MYKAD: 'Mykad'
}
